import { Typography } from "@mui/material";
import {
  type ProgressStateAdm,
  type ProgressStateDtg,
  type ProgressStateGbd,
  type ProgressStateVda,
  returnStepperValues,
  type StepLabel,
} from "@root/misc/constants";
import { getTranslatedText } from "@root/utils/ui";

interface Props {
  value: ProgressStateGbd | ProgressStateAdm | ProgressStateDtg | ProgressStateVda;
  testType: string;
}
export default function CurrentStep(props: Props): JSX.Element {
  const { labels, index } = returnStepperValues(props.testType, props.value);

  const getLabel = (label: StepLabel) => {
    switch (label.kind) {
      case "introduction":
        return getTranslatedText("nav.instruction_step.title");
      case "instruction2":
        return getTranslatedText("nav.instruction_step_two.title");
      case "practise":
        return getTranslatedText("nav.practise_step.title");
      case "test":
        return getTranslatedText("nav.test.title");
      case "test1":
        return getTranslatedText("nav.test_step_one.title");
      case "test2":
        return getTranslatedText("nav.test_step_two.title");
      case "end":
        return getTranslatedText("nav.end_step.title");
    }
  };
  return (
    <Typography
      variant="caption"
      noWrap
      component="div"
      sx={{ fontWeight: 700, display: "block", width: "25%", textAlign: "end" }}
    >
      {getLabel(labels[index])} - {index + 1} {getTranslatedText("nav.instruction_step.separator")}{" "}
      {labels.length}
    </Typography>
  );
}
